import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AdminSettings from "@/pages/admin/Settings";
import ProfilePage from "@/pages/shared/ProfilePage";

export default function SettingsHub() {
  const [tab, setTab] = useState("general");
  return (
    <div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="settings-tabs">
          <TabsTrigger value="general" data-testid="settings-tab-general">General</TabsTrigger>
          <TabsTrigger value="profile" data-testid="settings-tab-profile">Profile</TabsTrigger>
        </TabsList>
        <TabsContent value="general" data-testid="settings-panel-general"><AdminSettings /></TabsContent>
        <TabsContent value="profile" data-testid="settings-panel-profile"><ProfilePage /></TabsContent>
      </Tabs>
    </div>
  );
}
